<div class="ehe-me-direct-modal-component" id="eheMeRedirectModal">
	<app-white-verification-modal [title]="data?.title" [showCloseIcon]="false" [showButtons]="showButtons">
		<ng-container>
			<div>
				<p [innerHTML]="data?.content"></p>
			</div>
		</ng-container>
	</app-white-verification-modal>
</div>
<app-ehe-spinner></app-ehe-spinner>
